module.exports = __webpack_public_path__ + "static/media/stark_token.f36a0d6a.png";